import React__default from 'react';
import NotificationCountBadge from '../../NotificationBadge/NotificationCountBadge.js';
import { getStateStyle, getIconSize, getNotificationCountBadgeSize } from '../utils.js';
import { commonButtonStyle, flexCenterContainer, iconInContainerButtonStyle } from '../commonStyles.css.js';
import { buttonTextContainerStyle, buttonTextStyle, badgeInContainerButtonStyle } from './styles.css.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const AnchorButton = /*#__PURE__*/React__default.forwardRef(({
  text,
  size,
  leftIcon,
  rightIcon,
  count,
  className,
  color,
  style,
  props,
  children,
  block,
  ...restProps
}, ref) => {
  const iconSizePx = getIconSize(size);
  const notificationCountBadgeSize = getNotificationCountBadgeSize(size);
  const dynamicStyle = getStateStyle(color);
  return /*#__PURE__*/jsxs("a", {
    className: `${commonButtonStyle({
      size,
      color,
      block
    })} ${className ?? ""}`,
    style: { ...dynamicStyle,
      ...style
    },
    ref: ref,
    ...props,
    ...restProps,
    children: [!!leftIcon && /*#__PURE__*/jsx("div", {
      className: `${flexCenterContainer}`,
      children: /*#__PURE__*/React__default.createElement(leftIcon, {
        sizePx: iconSizePx,
        className: `${iconInContainerButtonStyle({
          color
        })}`
      })
    }), /*#__PURE__*/jsxs("span", {
      className: `${buttonTextContainerStyle}`,
      children: [/*#__PURE__*/jsxs("span", {
        className: buttonTextStyle,
        children: [text, children]
      }), typeof count === "number" && /*#__PURE__*/jsx(NotificationCountBadge, {
        container: "span",
        className: `${badgeInContainerButtonStyle({
          color
        })}`,
        size: notificationCountBadgeSize,
        text: count
      })]
    }), !!rightIcon && /*#__PURE__*/jsx("div", {
      className: `${flexCenterContainer}`,
      children: /*#__PURE__*/React__default.createElement(rightIcon, {
        sizePx: iconSizePx,
        className: `${iconInContainerButtonStyle({
          color
        })}`
      })
    })]
  });
});
AnchorButton.displayName = "AnchorButton";
export { AnchorButton as default };
